import {observer} from 'mobx-react';
import React from 'react';
import {contentLookupService} from '../../domain';
import {PromiseMessage, PromiseRetry} from '../../lib/components';
import {SidebarStore} from './SidebarStore';

@observer
export class SidebarLoaderState extends React.Component<{ store: SidebarStore }> {
  render() {
    const store = this.props.store;
    const state = contentLookupService.state;

    return (
      <>
        <PromiseMessage label="loading content structure" state={state} align="fill"/>
        <PromiseRetry state={state} retry={store.loadLookup} align="center"/>
      </>
    );
  }
}
